import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentSl = () => {
    return (
        <HighlightedText
            text="PREVZEMI SVOJ BONUS 325% Bonus + 400 BREZPLAČNIH VRTLJAJEV"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['SVOJ', 'BREZPLAČNIH']}
            breakBeforeWords={['325%', '+']}
            className={styles.text_content}
        />
    )
}
